import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase config (New Account)
const firebaseConfig = {
  apiKey: "AIzaSyCPGrBB7zXW14ompkFhDs0zyN8u3RN53vE",
  authDomain: "jtc-pos.firebaseapp.com",
  projectId: "jtc-pos",
  storageBucket: "jtc-pos.appspot.com",
  messagingSenderId: "837126375756",
  appId: "1:837126375756:web:a7a463b6c26567aa8327e9",
  measurementId: "G-SF38CQJ8ZG"
};

// Check if browser supports messaging (i.e., Chrome and HTTPS context)
const isSupportedBrowser = () => {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  const isSecureContext = window.isSecureContext; // Required for FCM
  return isChrome && isSecureContext;
};

// Initialize Firebase & Messaging
export const firebaseApp = isSupportedBrowser() ? initializeApp(firebaseConfig) : null;
export const messaging = firebaseApp ? getMessaging(firebaseApp) : null;